import { render, staticRenderFns } from "./inquiryQuotationProduct.vue?vue&type=template&id=1f4cf540&scoped=true"
import script from "./inquiryQuotationProduct.vue?vue&type=script&lang=js"
export * from "./inquiryQuotationProduct.vue?vue&type=script&lang=js"
import style0 from "./inquiryQuotationProduct.vue?vue&type=style&index=0&id=1f4cf540&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4cf540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4cf540')) {
      api.createRecord('1f4cf540', component.options)
    } else {
      api.reload('1f4cf540', component.options)
    }
    module.hot.accept("./inquiryQuotationProduct.vue?vue&type=template&id=1f4cf540&scoped=true", function () {
      api.rerender('1f4cf540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quote-by-product/inquiryQuotationProduct/inquiryQuotationProduct.vue"
export default component.exports